var _rect, _rect2, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 35,
    height: 35,
    rx: 9.5,
    stroke: "#14382D",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 15,
    width: 4,
    height: 14,
    fill: "#14382D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 10.5,
    r: 2.5,
    fill: "#14382D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 15h4v2h.1C20.8 15.8 22.3 15 24.5 15 28.6 15 29 17.7 29 21v8h-4v-7c0-1.7 0-3.8-2.3-3.8S20 19.9 20 21.9V29h-4V15z",
    fill: "#14382D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.547a9c43ad451fa96fbe9a486f01ba0c.svg";
export { ForwardRef as ReactComponent };